import React from 'react';

const Step3Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-3">
        Richiedi subito il tuo preventivo online con lo sconto in fattura del 65%.
        </div>
    );
}

export default Step3Infos;